import axios from "axios";
import config from "@/config/constants.js";
import {firestore} from "@/config/firebase";

export default {
    namespaced: true,
    state: {
        status: "",
        user: {},
        billing: JSON.parse(localStorage.getItem('sign_up_billing') || '{}') || {},
        name_owner: "",
        company_name: "",
        list_users: [],
        tenant_id: "",
        referral: "",
    },
    mutations: {
        referral(state, token) {
            state.referral = token;
        },
        loading(state) {
            state.status = "loading";
        },
        status(state, status) {
            state.status = status;
        },
        success(state, user) {
            state.user = user;
            state.status = "";
            // localStorage.setItem('sign_up_vendor', JSON.stringify(user));
        },
        nameOwner(state, name) {
            state.name_owner = name;
        },
        nameCompany(state, company_name) {
            state.company_name = company_name;
        },
        tenant(state, id) {
            state.tenant_id = id;
        },
        addListUser(state, listUser) {
            state.list_users = listUser;
        }
    },
    actions: {
        signup_vendor: function ({commit, state}, data) {
            let params = data;
            params['no_owner'] = true;
            params['tenant_id'] = state.tenant_id;
            params['signup_for'] = "vendor";
            params['billing_active'] = true;
            // Forward the signed invite token so the backend can authorize the
            // activation (captured from the invite link in add_name_owner).
            params['referral'] = state.referral;

            return new Promise(function (resolve, reject) {
                commit("loading");

                if (!config.api_url) {
                    commit("status", "error");
                    reject("API URL not configured");
                    return;
                }

                axios.post(config.api_url + 'users/me/activate', params)
                    .then(() => {
                        commit("success", data);
                        resolve();
                    })
                    .catch(err => {
                        commit("status", "error");
                        const errorMsg = err.response?.data?.message || "Unknown error";
                        reject(errorMsg);
                    })
            });
        },
        add_name_owner: function ({commit}, tokent) {
            commit("loading");
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async function (resolve, reject) {
                try {
                    let param = {
                        "referral": tokent,
                        "signup_for": "vendor"
                    }
                    commit("referral", tokent);

                    if (!config.api_url) {
                        throw new Error("API URL not configured");
                    }

                    const response = await axios.post(config.api_url + 'get_user', param);

                    if (response['data']['code'] && response['data']['code'] === "ERROR") {
                        commit("status", "error");
                    } else {
                        commit("nameOwner", response.data.name);
                        commit("nameCompany", response.data.company_name);
                        commit("tenant", response.data.tenant_id);
                    }
                    commit('status', '');
                    resolve(response);
                } catch (err) {
                    commit("status", "error");
                    const errorMsg = err.response?.data?.message || err.message || "Unknown error";
                    reject(errorMsg);
                }
            });
        },
        change_state_login: function () {
            const user = localStorage.getItem(config.token_key);
            const parse = JSON.parse(user);
            const key = {
                "user_id": parse.phone_number,
                "tenant_id": parse.tenant_id
            };
            return new Promise(function (resolve, reject) {
                axios.post(config.api_url + 'user_access_login', key)
                    .then(response => {
                        // $router.push("/vendor/vendor-admin-panel");
                        resolve(response);
                    })
                    .catch(err => {
                        reject(err.response.data.message);
                    })
            });
        },
        async save_customer({commit, state}, data) {
            commit("loading");
            if (state.tenant_id !== '') {
                let database = firestore;
                try {

                    let user_global = await database
                        .collection("users")
                        .where('phone_number', '==', data.phone_number)
                        .limit(1)
                        .get();

                    let user_details = await database
                        .collection('tenants')
                        .doc(state.tenant_id)
                        .collection("users")
                        .where('owner_id', '==', user_global.docs[0].id)
                        .limit(1)
                        .get();

                    await database
                        .collection('tenants')
                        .doc(state.tenant_id)
                        .collection("users")
                        .doc(user_details.docs[0].id)
                        .set({
                            customer_id: data.customer_id
                        }, {merge: true});

                    commit('status', '');

                } catch (error) {
                    return (409).json({
                        code: config.codes.error,
                        message: error
                    });
                }
            } else {
                // No user is signed in.
                commit('status', '');
            }

        }
    }
    ,
    getters: {
        user(state) {
            return state.user;
        },
        billing(state) {
            return state.billing;
        }
    },
    modules: {}
}
